import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

export default class IdlingBadge extends React.PureComponent {

    constructor(props) {
        super(props);
    }

    render() {
        const durationPrettyPrint = moment.duration(this.props.durationSeconds * 1000).humanize();
        if(this.props.loc)
            return (
                <div className="idling-badge">
                    {durationPrettyPrint}<br/>
                    {this.props.loc}
                </div>
            )
        else
            return (
                <div className="idling-badge">
                    {durationPrettyPrint}
                </div>
            )
    }
}

IdlingBadge.propTypes = {
    durationSeconds: PropTypes.number.isRequired
};
